import React from 'react';
// import NavBarComponent from 'components/NavBarComponent';

require('styles//Dashboard.css');

class HomeComponent extends React.Component {
  render() {
    return (
      <div className='dashboard-container'>
        {this.props.children}
      </div>
    );

    /*
    <NavBarComponent
      actions={this.props.actions}
      trybeName={this.props.trybeName}
      routes={this.props.routes}
      location={this.props.location}
    />
    */
  }
}

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/components/HomeComponent.js